import _get from 'lodash.get';
// import makeRequest from 'utils/makeRequest';
import reducerRegistry from 'reduxUtils/reducerRegistry';

const reducerName = 'videoModal';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_VIDEO_RHS_DATA = createActionName(
  'RECEIVE_VIDEO_RHS_DATA',
);
export const OPEN_VIDEO_MODAL = createActionName('OPEN_VIDEO_MODAL');
export const CLOSE_VIDEO_MODAL = createActionName('CLOSE_VIDEO_MODAL');

export function openVideoModal({ videoItem, path, isVideoSkipAds, ...data }) {
  return {
    type: OPEN_VIDEO_MODAL,
    payload: {
      videoItem,
      data,
      path,
      isVideoSkipAds,
    },
  };
}
export function closeVideoModal() {
  return {
    type: CLOSE_VIDEO_MODAL,
    payload: {
      //   videoMsid: undefined,
    },
  };
}

export default function reducer(state = {}, action = {}) {
  // console.log(action);
  switch (action.type) {
    case OPEN_VIDEO_MODAL: {
      return {
        ...state,
        isModalOpen: true,
        isVideoSkipAds: action.payload.isVideoSkipAds,
        videoItem: action.payload.videoItem,
        source: _get(action.payload, 'data.source'),
        path: action.payload.path,
      };
    }
    case CLOSE_VIDEO_MODAL: {
      return {
        ...state,
        isModalOpen: false,
        videoItem: undefined,
        source: undefined,
      };
    }
    default:
      return state;
  }
}
reducerRegistry.register(reducerName, reducer);
